import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import Fragments from '../fragments';

export const METADATA_LIST_SAVED = gql`
  subscription metadataListSaved {
    metadataListSaved {
      metadata {
        ...metadata
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.metadata}
  ${CommonFragments.messageHeaders}
`;
